import React, { useEffect } from 'react';
import AOS from 'aos';
import aboutimg from '../assets/img/about-5.webp';
import aboutimg2 from '../assets/img/about-2.webp';
import ceoimg from '../assets/img/ceo img.png';
import '../assets/css/main.css';
import about_poster from '../assets/img/about poster.png';

const About = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <section id="about" className="about section">
            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gy-4 align-items-center justify-content-between">

                    <div className="col-xl-5" data-aos="fade-up" data-aos-delay="200">
                        <span className="about-meta">MY CAREER GEMS EDUTECH</span>
                        <h2 className="about-title">Career Guidance and Expert Consultation Services</h2>
                        <p className="about-description" style={{textAlign:'justify'}}>
                            Understanding the intricacies of higher studies, career progression or professional development
                            systems is not easy, that is why sought out experts help based on their experiences. Regardless of
                            your educational qualification, as long as you are looking for guidance in furthering your career,
                            MyCareerGems will definitely help you in achieving your aspirations.
                        </p>

                        <div className="row feature-list-wrapper">
                            <div className="col-md-6">
                                <ul className="feature-list">
                                    <li><i className="bi bi-check-circle-fill"></i> Personalized career counseling</li>
                                    <li><i className="bi bi-check-circle-fill"></i> Career path planning and guidance</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <ul className="feature-list">
                                    <li><i className="bi bi-check-circle-fill"></i> Job placement support</li>
                                </ul>
                            </div>
                        </div>

                        <div className="info-wrapper">
                            <div className="row gy-4">
                                <div className="col-lg-5">
                                    <div className="profile d-flex align-items-center gap-3">
                                        <img src={ceoimg} alt="CEO Profile" className="profile-image" />
                                        <div>
                                            <h4 className="profile-name">Krishna Kumar</h4>
                                            <p className="profile-position">CEO &amp; Founder</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="contact-info d-flex align-items-start gap-3">
                                        <i className="bi bi-telephone-fill mt-2 text-white"></i>
                                        <div>
                                            <p className="contact-label mb-1">Call us anytime for career advice</p>
                                            <p className="contact-number mb-0  text-light">+91 74492 06853</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6" data-aos="fade-up" data-aos-delay="300">
                        <div className="image-wrapper">
                            <div className="images position-relative" data-aos="zoom-out" data-aos-delay="400">
                                <img src={aboutimg} alt="Business Meeting" className="img-fluid main-image rounded-4" />
                                <img src={aboutimg2} alt="Team Discussion" className="img-fluid small-image rounded-4" />
                            </div>
                            <div className="experience-badge floating">
                                <h3>10+ <span>Years</span></h3>
                                <p>Of experience in providing career guidance services</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
